import { useState, useEffect } from "react";
import { Timer } from "lucide-react";
import { getRemaining } from "../../lib/promo";

const Unit = ({ value, label }) => (
  <div className="flex flex-col items-center">
    <span className="grid place-items-center min-w-[3rem] rounded-lg bg-white/15 backdrop-blur px-2 py-1.5 font-heading font-extrabold text-xl text-white tabular-nums">
      {String(value).padStart(2, "0")}
    </span>
    <span className="mt-1 text-[10px] uppercase tracking-wider text-white/70">{label}</span>
  </div>
);

export const Countdown = () => {
  const [t, setT] = useState(getRemaining());

  useEffect(() => {
    const id = setInterval(() => setT(getRemaining()), 1000);
    return () => clearInterval(id);
  }, []);

  return (
    <div
      data-testid="promo-countdown"
      className="mt-6 flex flex-col sm:flex-row sm:items-center gap-4 rounded-2xl bg-gradient-to-r from-[#071A33] to-[#0B63F6] p-5"
    >
      <div className="flex items-center gap-2 text-white">
        <Timer className="h-5 w-5 text-[#16C7E8]" />
        <span className="font-heading font-bold">
          {t.ended ? "Promo telah berakhir — hubungi kami untuk penawaran terbaru" : "Promo berakhir dalam"}
        </span>
      </div>
      {!t.ended && (
        <div className="flex items-center gap-2 sm:ml-auto">
          <Unit value={t.days} label="Hari" />
          <span className="text-white/50 font-bold">:</span>
          <Unit value={t.hours} label="Jam" />
          <span className="text-white/50 font-bold">:</span>
          <Unit value={t.minutes} label="Menit" />
          <span className="text-white/50 font-bold">:</span>
          <Unit value={t.seconds} label="Detik" />
        </div>
      )}
    </div>
  );
};
